/**
 * Adresse PROPRE d'une fiche produit : `/shop/p/<nom-en-minuscules>-<8 car. de l'id>`.
 *
 * Avant le 18/10/2026, une fiche n'était qu'une fenêtre ouverte sur le
 * catalogue (`/shop?produit=<id>`) : Google y voyait le catalogue entier et
 * retenait /shop comme page officielle — 1 154 fiches « détectées, non
 * indexées ». Chaque produit a désormais une page à lui, servie avec son titre,
 * sa description et son contenu avant même le chargement du programme.
 *
 * Le NOM n'est là que pour être lisible (et parlant pour Google) : c'est le
 * suffixe de 8 caractères qui identifie la fiche (unique sur 1 691 produits au
 * 18/10/2026). Renommer un produit change l'adresse ; l'ancienne reste valable
 * et renvoie (301) vers la nouvelle.
 *
 * ⚠️ Copie identique côté serveur : `api/src/common/adresse-produit.ts`.
 */
export function slugProduit(nom: string): string {
  return (nom || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/œ/gi, 'oe')
    .replace(/æ/gi, 'ae')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 70)
    .replace(/-+$/g, '');
}

export function adresseProduit(p: { id: string; name: string }): string {
  const slug = slugProduit(p.name);
  const ref = String(p.id).slice(0, 8).toLowerCase();
  return `/shop/p/${slug ? `${slug}-` : ''}${ref}`;
}

/** Les 8 caractères d'identifiant en fin d'adresse, ou null. */
export function refDepuisAdresse(segment: string): string | null {
  const m = /(?:^|-)([0-9a-f]{8})$/i.exec(segment || '');
  return m ? m[1].toLowerCase() : null;
}
